// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2-YRX","left":"StickyBox_left__1yyGp","right":"StickyBox_right__QNDUC"};